import React from 'react';
import {
	SelectInput,
	TextInput,
	refreshView,
	useNotify,
	useTranslate,
	useCreate,
} from 'react-admin';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import ResolveIcon from '@material-ui/icons/Build';
import BaseDialog from '../../components/dialog/BaseDialog';

const ResolveUnmatchedPayment = ({ id }) => {
	const dispatch = useDispatch();
	const notify = useNotify();
	const translate = useTranslate();
	const [resolveUnmatchedPayment] = useCreate('unmatchedPayments');

	const handleSubmit = (data, hideDialog) => {
		let method;
		if (data.entityType === 'System') {
			method = 'resolveToSystemAccount';
		} else {
			method = 'resolveToEntity';
		}
		resolveUnmatchedPayment(
			{
				payload: {
					id,
					data,
					method,
				},
			},
			{
				onSuccess: () => {
					notify('resources.unmatchedPayments.notifications.successfullyResolved', 'info');
					dispatch(refreshView());
					hideDialog();
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	return (
		<BaseDialog
			icon={<ResolveIcon />}
			buttonLabel={translate('resources.unmatchedPayments.actions.resolve')}
			dialogTitle={translate('resources.unmatchedPayments.labels.resolve')}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={{
						description: '',
						entityType: null,
						entityId: '',
					}}
					onSubmit={values => handleSubmit(values, hideDialog)}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<TextInput variant="standard" source="description" fullWidth />
							<SelectInput
								variant="standard"
								source="entityType"
								choices={[
									{ id: 'Wallet', name: 'Wallet ID' },
									{ id: 'WalletAccount', name: 'Wallet account ID' },
									{ id: 'PaymentInstrument', name: 'Payment instrument ID' },
									{
										id: 'paymentInstrumentVerificationProcess',
										name: 'Payment instrument verification process ID'
									},
									{ id: 'Payment', name: 'Payment ID' },
									{ id: 'Purchase', name: 'Purchase ID' },
									{ id: 'System', name: 'System ID' }
								]}
								resettable
								fullWidth
							/>
							<TextInput variant="standard" source="entityId" fullWidth />
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

export default ResolveUnmatchedPayment;
